import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core, Decorative } from "@faire/design-tokens";
import { popSignUp, SignUpElement, SignUpType } from "@faire/retailer-visitor-shared/lib/popSignUp";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import React from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
export var SignUpProductGridBanner = function(param) {
    var info = param.info;
    var history = useHistory();
    var onSignUpClick = function() {
        popSignUp(history, SignUpType.GENERIC, function() {}, {
            element: SignUpElement.PRODUCT_GRID,
            sourceId: "logged_out_sign_up_product_grid_banner"
        });
    };
    var strictLocalize = useStrictLocalization().strictLocalize;
    var buttonLabel = strictLocalize({
        id: "XIKva+",
        defaultMessage: [
            {
                type: 0,
                value: "Sign up for free"
            }
        ]
    });
    return /*#__PURE__*/ _jsxs(StyledColumn, {
        align: "center",
        justify: "center",
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                align: "center",
                variant: "pageHeaderSerifRegular",
                children: info.title
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "1x"
            }),
            /*#__PURE__*/ _jsx(Typography, {
                align: "center",
                variant: "paragraphSansRegular",
                children: info.subtitle
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "2x"
            }),
            /*#__PURE__*/ _jsx(Button, {
                onClick: onSignUpClick,
                variant: "primary",
                children: buttonLabel
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "3x"
            }),
            /*#__PURE__*/ _jsx(Typography, {
                align: "center",
                variant: "labelSansRegular",
                children: info.bottom_label
            })
        ]
    });
};
var StyledColumn = styled(Column).withConfig({
    componentId: "sc-30c5c4c5-0"
})([
    "height:100%;border:1px solid ",
    ";padding:",
    ";border:none;background-color:",
    ";"
], Core.border.muted, getSpacing("6x", "3x"), Decorative.tint.neutral);
